import React from "react";
import './ProjetTest.css';

const Apropros = () =>{

    return(
        <>
<div className="envelope-projeto">
    
    
 
        <div className="banner-projeto">
            <div className="poster_onglet">
              
                </div>
                <div className="poster_onglet_700">
              
              </div>
        </div>
        
     <div className="container-objectifs">    
     <div className="les-apropos" id="">
     
        <div className="les-apropos-text">
            <div className="les-apropos-text inicio">
                <p className="p-apropos"> Luxembourg multi-LEARN Institute asbl</p>
            </div>
            <div className="text-principal">
         
            <div className="text-apropos">
             <p className="text-apropos-body-text">
                <br></br>

       
             Luxembourg multi-LEARN Institute asbl promeut l'apprentissage et le développement en interaction et au travers de la diversité. L'association a été impliquée depuis sa création en 2008 dans la conception et la réalisation de différentes initiatives (recherches, projets et formations) au Luxembourg et au-delà. L'association propose une réflexion critique sur les processus liés au développement de la littératie, de l'intégration et de l'interaction dans différents domaines de la vie quotidienne. En plus d'une analyse approfondie et de l'évaluation des problématiques qui lui sont soumises, elle offre des solutions pratiques, émergeant des terrains, et délivre des recommandations.
            <br></br>
            <a className='link-ml' href='https://multi-learn.org/'target="_blank" rel="noopener noreferrer">www.multi-learn.org</a>

            </p>   
         
           </div>
           </div>
        </div>
       

</div>

    

           
   

</div>  
</div>

        </>
    );
}

export default Apropros;